const defaultValues = {
  icon: "circle",
  color: "red",
  lineStyle: "lineStyle_SOLID",
  canDelete: true
};

const getRecessiveValues = v2Role => {
  return {
    id: v2Role.guid
  };
};

const getDominantValues = (v2Role, typeId) => {
  return {
    types: [typeId],
    label: v2Role.name,
    icon: v2Role.icon,
    showInInspector: true
  };
};

export default (v3Reference, v2Role, typeId) => {
  return Object.assign(
    {},
    defaultValues,
    getRecessiveValues(v2Role, typeId),
    v3Reference,
    getDominantValues(v2Role, typeId)
  );
};

// export default (v2Role, typeId) => {
//   return {
//     id: v2Role.guid,
//     types: [typeId],
//     label: v2Role.name,
//     icon: v2Role.icon,
//     color: "red",
//     lineStyle: "lineStyle_SOLID",
//     canDelete: false
//   };
// };
